export const baseInputStyle =
  'w-full rounded border-[1.5px] bg-transparent px-5 py-3 text-black outline-none transition focus:border-primary active:border-primary border-[#EFEFEF] disabled:border-gray-100 disabled:bg-gray-50 disabled:text-gray-400';
